import styled from '@emotion/styled/macro';
import {forPhoneOnly, Layout, Variables} from '@enter/core';
import { Icon } from '@mdi/react';
import {ApproveActionButton} from "../../../components/action-button/approve-action-button";

export const TabsContainer = styled.div`
    padding-top: 20px;
    padding-left: 16px;
    padding-bottom: 10px;
`;

export const HeaderContainer = styled.div`
    padding-top: 5px;
    padding-left: 5px;
    padding-bottom: 5px;
`;

export const SubPageLayout = styled(Layout)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 28px;
    overflow-x: hidden;
    overflow-y: auto;

    ${forPhoneOnly(`
        margin-left: 0;
        padding: 16px;
        height: 100%;
    `)};
`;

export const SubTitle = styled.div`
  display: flex;
  padding-top: 5px;
`

export const SubHeader = styled.div`
  display: flex;
  padding-bottom: 10px;
  padding-left: 20px;
`

export const FlexBreak = styled.div`
    flex-basis: 100%;
    height: 0;
`

export const PageLayoutHeader = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  flex-direction: row;
`;


export const Cell = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    padding: 8px 0px;
`;

export const StyledIcon = styled(Icon)`
    margin-top: 4px;
    height: 16px;
    width: 16px;
    fill: ${Variables.Colors.b300};
    align-self: flex-end;
`;

export const Expand = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: 0;
`;

export const ExpandTable = styled.table`
    white-space: normal;
    color: ${Variables.Colors.n100};
    padding: 16px 24px;
    width: auto;
    margin: 0 24px 24px 24px;
`;
export const ExpandTBody = styled.tbody`
    padding-top: 16px;
`;
export const ExpandTR = styled.tr``;
export const ExpandTH = styled.th`
    text-align: left;
    vertical-align: top;
    padding-right: 1em;
    font-weight: 500;
    white-space: nowrap;
`;
export const ExpandTD = styled.td``;
export const ExpandTitle = styled.h3`
    margin: 18px 0 0 0;
    font-weight: 500;
    font-size: 16px;
    text-decoration: underline;
`;

export const ActionButton = styled(ApproveActionButton)`
    margin-right: 16px;
`;